import React from "react";
import dayjs from "dayjs";
import {Col, Row} from "antd";
import PropTypes from 'prop-types';

import BookingCostBreakDown from "./BookingCostBreakdown";
import TaxableTransactionBreakdown from "./TaxableTransactionBreakdown";
import NontaxableTransactionBreakdown from "./NontaxableTransactionBreakdown";
import {isEstimatedCost} from "../../../helpers/booking";

import './CostBreakdown.less';
import JourneyDetailsCard from "../../booking/JourneyDetailsCard";

const CostBreakdown = ({transaction}) => {
    const {amount, transactable, transactable_type} = transaction;
    const isJourney = transactable_type.includes('Journey');
    const isCharge = transactable_type.includes('Charge');

    // Return different component based on type of cost breakdown.
    const getRenderComponent = () => {
        let component;

        if (isJourney === true) {
            // Journeys are capable of not having a booking. In which case some of these properties are not valid.
            const costs = transactable.booking ? transactable.booking.costs : transactable.journey_costs;
            const taxes = transactable.booking ? transactable.booking.taxes : transactable.journey_taxes;
            const ended_at = transactable.booking ? transactable.booking.booking_deployment.ended_at : transactable.billing_ended_at;
            const state = transactable.booking ? transactable.booking.booking_deployment.state : 'CONFIRMED';

            const estimatedCost = isEstimatedCost(state, costs, dayjs().tz(), ended_at);
            const totalCost = isJourney ? costs.reduce((total, cost) => {
                return total + parseFloat(cost.amount);
            }, 0) : null;

            const totalTax = isJourney ? taxes.reduce((total, cost) => {
                return total + parseFloat(cost.amount);
            }, 0) : null;

            component = getBookingTransactionComponent(costs, totalCost, estimatedCost, taxes, totalTax, amount);

        } else if (isCharge === true) {
            component = getTaxableTransactionComponent();
        } else {
            component = getNonTaxableTransactionComponent();
        }

        return component;
    }

    const getBookingTransactionComponent = (costs, totalCost, estimatedCost, taxes, totalTax, transactionAmount) => {
        return (
            <Row justify='center'>
                <Col xs={24} md={12} xl={12} className="cost-breakdown-col">
                <JourneyDetailsCard journeyID={transactable.booking.journey_id} />
                </Col>
                <Col xs={24} md={12} xl={12} className="cost-breakdown-col">
                <BookingCostBreakDown
                     costs={costs}
                     totalCost={totalCost}
                     isEstimatedCost={estimatedCost}
                     taxes={taxes}
                     totalTax={totalTax}
                     transactionsTable={true}
                     transactionAmount={transactionAmount}
                />
                </Col>
            </Row>
        )
    }

    const getTaxableTransactionComponent = () => {
        return (
            <Row justify='start'>
                <Col xs={14} md={10} lg={8} xl={6} className="cost-breakdown-col">
                    <TaxableTransactionBreakdown transaction={transaction} />
                </Col>
            </Row>
        )
    }

    const getNonTaxableTransactionComponent = () => {
        return (
            <Row justify='start'>
                <Col xs={14} md={10} lg={8} xl={6} className="cost-breakdown-col">
                    <NontaxableTransactionBreakdown transaction={transaction} />
                </Col>
            </Row>
        )
    }

    return <>
        {
            getRenderComponent()
        }
    </>
};

export default CostBreakdown;

CostBreakdown.propTypes = {
    transaction: PropTypes.shape({
        transactable: PropTypes.object.isRequired,
        amount: PropTypes.string.isRequired,
    }).isRequired,
};
